import React from 'react';
import { IntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
import { ThemeProvider, GlobalFontFace } from '@match/react-component-library';
import { SuccessStoryPage } from 'modules/pages';
import { GlobalCssReset } from 'modules/components';
import { useBrandName, useLocale, useSiteCode } from 'modules/hooks';
import { themeBuilder } from 'utils/theme-builder';
import { SiteCode, SITECODE } from '@match/app-rules-resolver';

const getPageTitle = (siteCode: SiteCode) => {
  switch (siteCode) {
    case SITECODE.STIR:
      return 'Stir Success Stories';
    case SITECODE.OUR_TIME:
      return 'Ourtime Success Stories';
    default:
      return 'MatchMade Success Stories';
  }
};

const getPageMetaText = (siteCode: SiteCode, brandName: string) => {
  if (siteCode === SITECODE.OUR_TIME) {
    return 'Real Love After 50. Stories that deserve to be told.';
  }

  return `${brandName} has helped create over a million love stories. If you’ve found someone special on ${brandName}, spread the love! Share your story with us today.`;
};

const App = () => {
  const { locale } = useLocale();
  const { siteCode } = useSiteCode();
  const { brandName } = useBrandName();
  const currentLocale = locale;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const messages = require(`i18n/${currentLocale}-messages.json`);
  const successTheme = themeBuilder(siteCode);

  const titleText = getPageTitle(siteCode);
  const metaText = getPageMetaText(siteCode, brandName);

  return (
    <IntlProvider locale={currentLocale} messages={messages}>
      <ThemeProvider theme={successTheme}>
        <Helmet>
          <title>{titleText}</title>
          <meta name="description" content={metaText} />
        </Helmet>
        <GlobalFontFace />
        <GlobalCssReset padding margins borderBox />
        <SuccessStoryPage />
      </ThemeProvider>
    </IntlProvider>
  );
};

export default App;
